
    import "src/shared/components/UploadBulkModal/index.module.scss?farm_css_modules";
    
    export default {"buttonsContainer": `buttonsContainer-9e9dd516`,"errorList": `errorList-9e9dd516`,"fileDetails": `fileDetails-9e9dd516`,"fileName": `fileName-9e9dd516`,"heading": `heading-9e9dd516`,"instructions": `instructions-9e9dd516`,"uploadBulkModal": `uploadBulkModal-9e9dd516`,"uploadButton": `uploadButton-9e9dd516`,"uploadLabel": `uploadLabel-9e9dd516`}
    